import { render, staticRenderFns } from "./LeaderboardLockedTeamComponent.vue?vue&type=template&id=0af68913&scoped=true&"
import script from "./LeaderboardLockedTeamComponent.vue?vue&type=script&lang=ts&"
export * from "./LeaderboardLockedTeamComponent.vue?vue&type=script&lang=ts&"
import style0 from "./LeaderboardLockedTeamComponent.vue?vue&type=style&index=0&id=0af68913&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af68913",
  null
  
)

export default component.exports